var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M11.9108 13.9226C11.5854 13.5972 11.5854 13.0695 11.9108 12.7441C12.2363 12.4186 12.7639 12.4186 13.0893 12.7441L16.4227 16.0774C16.7481 16.4028 16.7481 16.9305 16.4227 17.2559C16.0972 17.5814 15.5696 17.5814 15.2442 17.2559L11.9108 13.9226Z",
    fill: "#009EF6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33325 9.16683C3.33325 12.3885 5.94492 15.0002 9.16658 15.0002C12.3882 15.0002 14.9999 12.3885 14.9999 9.16683C14.9999 5.94517 12.3882 3.3335 9.16658 3.3335C5.94492 3.3335 3.33325 5.94517 3.33325 9.16683ZM13.3333 9.16686C13.3333 11.468 11.4678 13.3335 9.16659 13.3335C6.86541 13.3335 4.99993 11.468 4.99993 9.16686C4.99993 6.86567 6.86541 5.00019 9.16659 5.00019C11.4678 5.00019 13.3333 6.86567 13.3333 9.16686Z",
    fill: "#009EF6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.c1aad08584b2a5830e5c76e360c69cb9.svg";
export { ForwardRef as ReactComponent };